import { takeEvery, put, select } from 'redux-saga/effects'

import { tracking as trackingActions } from 'flux/actions'
import { property as propertySelectors } from 'flux/selectors'

export function* onFbQ({ payload: { args } }) {
  // if cookies not consent will not send any event
  const isProfilingConsent = yield select(propertySelectors.selectIsProfilingConsent)
  if (!isProfilingConsent) return

  // @see https://developers.facebook.com/docs/ads-for-websites/pixel-events/v3.0
  window.fbq(...args)
}

export function* onInit({ payload: { pixel } }) {
  yield put(trackingActions.fbQ('init', pixel))
  yield put(trackingActions.fbQ('track', 'PageView'))
}

export function* onEvent({ payload: { name, params } }) {
  yield put(trackingActions.fbQ('track', name, params))
}

export function* onCustom({ payload: { name, params } }) {
  yield put(trackingActions.fbQ('trackCustom', name, params))
}

export default function* () {
  yield takeEvery(trackingActions.types.FB_Q, onFbQ)
  yield takeEvery(trackingActions.types.FB_INIT, onInit)
  yield takeEvery(trackingActions.types.FB_EVENT, onEvent)
  yield takeEvery(trackingActions.types.FB_CUSTOM, onCustom)
}
